import React from "react";
import styled from "styled-components";
import { FaCheck } from "react-icons/fa6";
import Footer from "./components/footer";

const KrPaymentSuccess = () => {
  return (
    <Wrapper>
      <Container>
        <LogoArea>
          <a href="https://phoneboxmobile.com/">
            <img src="/images/phonebox-logo.png" alt="PhoneBox Logo" />
          </a>
        </LogoArea>

        <SuccessContent>
          <SuccessIconOuter>
            <SuccessIconInner>
              <FaCheck />
            </SuccessIconInner>
          </SuccessIconOuter>

          <Title>개통 신청이 완료되었어요.</Title>

          <Subtitle>결제가 정상적으로 처리되었습니다.</Subtitle>

          {/* <ReferenceText>
            주문번호: <ReferenceNumber>{"{Ref#}"}</ReferenceNumber>
          </ReferenceText> */}

          <NoticeBox>
            <ul>
              <li>
                영수증은 고객님의 이메일로 전달되었어요. 자세한 구매 내역은
                이메일을 확인해주세요.
              </li>
              <li>캐나다 휴대폰 번호는 개통일에 이메일로 발송됩니다.</li>
            </ul>
          </NoticeBox>
        </SuccessContent>

        <Separator />

        <Footer />
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background: #f7f9fc;
  min-height: 100vh;
  padding: 10px 0;
`;

const Container = styled.div`
  max-width: 1000px;
  margin: 30px auto;
  padding: 64px 64px 32px;
  border-radius: 24px;
  background: white;
  box-shadow:
    0 -2px 4px 0 rgba(0, 79, 232, 0.1) inset,
    0 0 8px 0 rgba(0, 62, 181, 0.12);
  font-family: "Helvetica", "Arial", sans-serif;

  @media (max-width: 992px) {
    max-width: none;
    margin: 1rem 0 0;
    padding: 1rem;
  }
`;
const LogoArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* margin-bottom: 70px; */

  img {
    height: 40px;
    width: auto;
  }

  @media (max-width: 768px) {
    margin-bottom: 48px;

    img {
      height: 32px;
    }
  }
`;
const SuccessContent = styled.div`
  padding: 48px 0 34px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const SuccessIconOuter = styled.div`
  width: 98px;
  height: 98px;
  border-radius: 999px;
  background: #dcfce7;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 26px;
`;

const SuccessIconInner = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 999px;
  border: 6px solid #16a34a;
  color: #16a34a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
`;

const Title = styled.h1`
  margin: 0 0 22px;
  color: #2b2b2b;
  font-size: 32px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: -0.5px;
`;

const Subtitle = styled.p`
  margin: 0 0 10px;
  color: #999;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.5;
`;

// const ReferenceText = styled.p`
//   margin: 0 0 24px;
//   color: #999;
//   font-size: 17px;
//   font-weight: 500;
// `;

// const ReferenceNumber = styled.span`
//   color: #ff6b00;
//   font-weight: 800;
// `;

const NoticeBox = styled.div`
  width: 100%;
  margin-top: 20px;
  max-width: 560px;
  border-radius: 14px;
  background: #fff1e8;
  padding: 18px 22px;
  color: #ff6b00;
  text-align: left;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.65;

  ul {
    margin: 0;
    padding-left: 18px;
  }
`;

const Separator = styled.hr`
  margin: 30px 0;
  border: none;
  border-top: 1px solid #ddd;
`;

export default KrPaymentSuccess;
